import { Route, NavigationGuardNext } from 'vue-router';
import { redirect } from '@/helpers/redirects';

const validateSitterUuid = (to: Route, _from: Route, next: NavigationGuardNext) => {
  const sitterUuid = to.params.sitter_uuid;

  // Check if sitter UUID is missing
  if (!sitterUuid) {
    redirect('/bookings?notification=Sitter%20profile%20could%20not%20be%20found');
    return;
  }

  // Basic UUID format validation (8-4-4-4-12 hex characters)
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  if (!uuidRegex.test(sitterUuid as string)) {
    redirect(`/bookings?notification=${encodeURIComponent('Invalid sitter profile')}`);
    return;
  }

  next();
};

export default validateSitterUuid;
